var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCarWashinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 5h50M33.61 53H10V40.387Q10 36 15.62 36h32.76Q54 36 54 40.387V53z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.5 47a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm27 0a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zM32 22h7.824c5.029 0 5.546 1.196 7.823 6.462Q49.924 33.727 51 36H13q1.076-2.273 3.353-7.538C18.63 23.196 19.147 22 24.176 22zM16 53v6m32-6v6M21 8s3 3.578 3 5.151C24 14.725 22.657 16 21 16s-3-1.275-3-2.849C18 11.578 21 8 21 8zm11 0s3 3.578 3 5.151C35 14.725 33.657 16 32 16s-3-1.275-3-2.849C29 11.578 32 8 32 8zm11 0s3 3.578 3 5.151C46 14.725 44.657 16 43 16s-3-1.275-3-2.849C40 11.578 43 8 43 8z"
}))));
export default SvgCarWashinline;